import RobotHandMobileIcon from './RobotHandMobileIcon'

export default RobotHandMobileIcon
